import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getStripeKey() {
    return this.http.get<any>(`${environment.apiUrl}/payment/key`)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  savePaymentMethod(stripeToken: string) {
    return this.http.post<any>(`${environment.apiUrl}/payment/method`, {
        token_id: stripeToken,
      })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  getPaymentMethod() {
    return this.http.get<any>(`${environment.apiUrl}/payment/methods`)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  subscribe(methodId: number) {
    return this.http.post<any>(`${environment.apiUrl}/payment/subscribe`, {
      method_id: methodId,
    })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  subscribeWithoutDevice(methodId: number) {
    return this.http.post<any>(`${environment.apiUrl}/payment/subscribe_without_device`, {
      method_id: methodId,
    })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

}
